import React from "react";
import Page from "../components/Page";

function ErrorPage() {
  return (
    <Page data-wf-page="6350a8a37f76291f39fe7191" data-wf-site="634efd6b20b65bfc05be44e4">
      <div className="utilitypagewrap">
        <div className="utilitypagecontent">
          <h1 className="heading404">404</h1>
          <h2>Page&nbsp;Not Found.</h2>
        </div>
      </div>
    </Page>
  );
}

export default ErrorPage;
